import styles from 'components/Registration/Form/signupStyles.module.css'

const Footer = (props) => {
    return (
        < footer className={`${styles.foot_sec}`}>
            <p
                className="mb-0"
                style={{
                    textAlign: 'center',
                    fontSize: '14px',
                    color: 'white',
                }}
            >
                &copy; {window.location.pathname =='/neet-repeater-scholarship' ? 2027: new Date().getFullYear()} All right reserved by Aakash
                Educational Services Limited | Email us:{' '}
                <a
                    style={{ textDecoration: 'none', color: 'white' }}
                    href={`mailto:${props.supportEmail}`}
                >
                    {props.supportEmail}
                </a>
            </p>
        </footer >
    )
}

export default Footer